import { AxiosRequestConfig } from "axios";
import baseApi, { fetchApi, version1 } from "../../Libs/Config/APIConfig";
import { BEARER_TOKEN } from "../../Libs/Utils/utils";

interface CustomAxiosRequestConfig<T = unknown> extends AxiosRequestConfig<T> {}
const AuthDataFormConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

const BaseDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiGetPreAuthList = async () => {
  return baseApi.get(`/api/${version1}/preauthorization/`, BaseDataConfig);
};

export const apiAddPreAuth = async (payload: FormData) => {
  const configWithAuth: CustomAxiosRequestConfig = {
    ...AuthDataFormConfig,
    headers: {
      ...AuthDataFormConfig.headers,
      Authorization: `Bearer ${BEARER_TOKEN}`,
    },
  };
  return fetchApi.post(
    `/api/${version1}/preauthorization/preauth-with-documents`,
    payload,
    configWithAuth
  );
};

export const apiGetPreAuthStatusByReferenceNumber = async (payload: string) => {
  return fetchApi.get(
    `/api/${version1}/preauthorization/preauth-status?reference_number=${payload}`,
    BaseDataConfig
  );
};
